import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';


bootstrapApplication(AppComponent, appConfig).then(() => {
    if ('serviceWorker' in navigator && (environment.production || environment.preproduction || environment.development)) {
      navigator.serviceWorker.register('ngsw-worker.js');
    }
})
.catch((err) => console.log(err));